import React, { useEffect, useRef, useState } from "react";
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEdit,
    faPlus,
    faSort,
    faTrash,
    faPenToSquare,
    faTimes,
  } from "@fortawesome/free-solid-svg-icons";
import clientDemoImg from "../assets/img/EmptyLogo.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import ReactDOM from "react-dom";
import { commonAPI } from "../services/CommonAPIService";
import Menus from "./menus";
// import { Wizard, Steps, Step, WithWizard } from "react-multistep-wizard";
// import SlideButton from "react-slide-button";
import { Stepper, Step, StepLabel } from "@mui/material";
// import  clientimg  from '../assets/img/clientimg.jpg';
// import  clientimg2  from '../assets/img/clientimg-2.jpg';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import INDFlag from "../assets/img/INDFlag.jpg";
import filepreview from '../assets/img/filepreview.png';
import { ErrorSource } from "../common/constants";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
 import switchBaseClasses from "@mui/material/internal/switchBaseClasses";
 import { styled } from '@mui/material/styles';
 import FormGroup from '@mui/material/FormGroup';
 import FormControlLabel from '@mui/material/FormControlLabel';
 import noticeuserupload from '../assets/img/noticeuserupload.png';
 import Switch, { SwitchProps } from '@mui/material/Switch';
 import Stack from '@mui/material/Stack';
 import Typography from '@mui/material/Typography';
 import JoditEditor from 'jodit-react';
 import Form from 'react-bootstrap/Form';
 import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Table from 'react-bootstrap/Table'; 
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';

function SmsConfig() {
    const [fullscreen, setFullscreen] = useState(true);
    const [activeStep, setActiveStep] = useState(0);
    const steps = ["Step 1", "Step 2", "Step 3"];
    const [show, setShow] = useState(false);
    const [showFirstModal,setShowFirstModal] = useState(false)
    const [Loading, setLoading] = useState(false);
    const [NoticeList, setNoticeList] = useState("");
    const [NoticeSubject, setNoticeSubject] = useState("");
    const [NoticeDescription, setNoticeDescription] = useState("");
    const [NoticeEmail, setNoticeEmail] = useState();
    const [NoticeId, setNoticeId] = useState();
    const [Importance, setImportance] = useState();
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [NoticeType, setNoticeType] = useState("");
    const [NoticeTypeId, setNoticeTypeId] = useState();
    const [NoticeTypeText, setNoticeTypeText] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageShow, setSelectedImageShow] = useState(null);
    const [selectedImageTwo, setSelectedImageTwo] = useState(null);
    const [selectedImageTwoShow, setSelectedImageTwoShow] = useState(null);
    const [firstSectionButton, setFirstSectionButton] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddNoticeBtn, setAddNoticeBtn] = useState(false);
    const [UpdateNoticeBtn, setUpdateNoticeBtn] = useState(false);


    
      const openCreateModalagain = () => {
        setShowFirstModal(true);
        setAddNoticeBtn(true);
        setUpdateNoticeBtn(false);
        setNoticeSubject("");
        setNoticeDescription("");
        setNoticeEmail("");
        setImportance("");
        setStartDate("");
        setEndDate("");
        setSelectedImage("");
        setSelectedImageTwo("");
      };

         

 

      const handleClose = () => setShow(false);
      const handleShow = () => setShow(true);

      const [state, setState] = React.useState({
        gilad: true,
        jason: false,
        antoine: false,
      });
    
      // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      //   setState({
      //     ...state,
      //     [event.target.name]: event.target.checked,
      //   });
      // };
    
      const { DLF, Magnolias, Bestech ,Kraheja } = state;
      const error = [DLF, Magnolias, Bestech ,Kraheja].filter((v) => v).length !== 2;
    
  return (
    <> 

<div className="row mb-1" style={{ alignItems:'center' }}>
        <div className="col-md-4 mt-5 pt-2">
          <div className="HeadingTop">
            <h3> SMS Config   </h3>
            <span> List of Curo Solution Sms Config</span>
          </div>
        </div>
        <div className="col-md-3 offset-md-5 text-right">
        {/* <Button  onClick={() => openCreateModalagain()} className="createClr">
                              {" "}    Copy Settings <FontAwesomeIcon icon={faCopy} />
                      </Button>{" "}  */}
        </div>
      </div>
      <div className="row mb-3" style={{ alignItems:'center' }}>
             <div className="col-lg-12 col-md-12 col-sm-12 col-12">
             <div className="tableFixHead">
              <div className="scrolling_tbl">
              <Table striped responsive="lg">
          <thead>
            <tr>
              
              <th>SMS Provider</th>
              <th>API End Point</th>
              <th>AuthKey1</th>
              <th>AuthKey2 </th>
              <th>RouteId</th>
              <th>SenderId</th>
              <th>Status</th>
              <th>Edit</th>
              {/* <th>Delete</th> */}
            </tr>
          </thead>
          <tbody>
            <tr>
          
              <td>Airtel</td>
              <td>8081</td>
              <td>101</td>
              <td>201</td>
              <td>198.54.0.1</td>
              <td>RP01</td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
          
            <td>Jio</td>
              <td>8091</td>
              <td>102</td>
              <td>202</td>
              <td>198.34.0.11</td>
              <td>RP02</td>
              <td>Inactive</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
          
            <td>Jio</td>
              <td>8091</td>
              <td>103</td>
              <td>203</td>
              <td>192.94.20.1</td>
              <td>RP03</td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
            <td>Vodafone Idea</td>
              <td>6671</td>
              <td>104</td>
              <td>204</td>
              <td>192.44.40.1</td>
              <td>RP04</td>
              <td>Active</td>
              <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
              {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
            </tr>
            <tr>
          
            <td>Airtel</td>
              <td>8081</td>
              <td>105</td>
              <td>205</td>
              <td>195.64.0.91</td>
              <td>RP05</td>
              <td>Inactive</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
          
          <td>Jio</td>
              <td>8881</td>
              <td>106</td>
              <td>206</td>
              <td>196.6.0.9</td>
              <td>RP06</td>
              <td>Active</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
          
          <td>Vodafone Idea</td>
              <td>6671</td>
              <td>107</td>
              <td>207</td>
              <td>192.44.40.1</td>
              <td>RP07</td>
              <td>Inactive</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          <tr>
          
          <td>Jio</td>
              <td>8091</td>
              <td>108</td>
              <td>208</td>
              <td>198.86.28.1</td>
              <td>RP08</td>
              <td>Active</td>
            <td><FontAwesomeIcon className="editNotice" icon={faEdit} /></td>
            {/* <td><FontAwesomeIcon className="deleteNotice" icon={faTrash} /></td> */}
          </tr>
          </tbody>

        </Table>
        
              </div>
            </div>  
      <div className="table_ntr">
        
         <input placeholder='SMS Provider' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" /> 
       <input placeholder='API End Point' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" /> 
       <input placeholder='AuthKey1' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" /> 
        <input placeholder='AuthKey2' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
        <input placeholder='RouteID' type="text" class="form-control required" id="wlastName2" name="lastName" aria-required="true" value="" />
        <select size="sm" className="sltareamodal col-2 ml-auto"  style={{height: "30px"}}>
        <option value="Approved">Active</option>
        <option value="Denied"> Inactive </option> 
         
    </select>
        <Button  onClick={() => openCreateModalagain()} className="createClr bg-secondary" style={{height: "30px"}}>
          {" "}    Cancel
        </Button>{" "} 
        <Button  onClick={() => openCreateModalagain()} className="createClr" style={{height: "30px"}}>
          {" "}<FontAwesomeIcon icon={faPlus} />    Add  
        </Button>{" "} 
      </div>
             </div>
        </div>
 

      <Modal  size="sm" show={showFirstModal}
        onHide={() => setShowFirstModal(false)}>
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title onClick={openCreateModalagain}> SMS Config</Modal.Title>
        </Modal.Header>
        <Modal.Body> 
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 col-12">
            <span>Building </span> 
            </div>
            <div className="col-lg-9 col-md-9 col-sm-12 col-12">
            <div className="subPopup">

<select size="md" className="sltareamodal col-12 ml-auto"  >
        <option value="Geeral">Building 1</option>
        <option value="Alert"> Building 2</option>
        <option value="Warning">Building 3</option>
         
    </select>
</div>
</div>
          </div>
 

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Copy Sms Config
          </Button>
        </Modal.Footer>
      </Modal>
 
    
</>
  );
}
export default SmsConfig;
